import { parseExtensionId } from '@atlassian/forge-ui/utils/parseExtensionId';

import type { ForgeExtension, ForgeExtensions } from '../../../../../../../../common/types/apps';

export const normalizeExtensions = (
	forgeExtensions: ForgeExtensions,
): { [key: string]: ForgeExtension } =>
	forgeExtensions.reduce<Record<string, ForgeExtension>>((accumulator, current) => {
		const { appId, environmentId: envId } = parseExtensionId(current.id);

		const combinedAppEnvId = `${appId}/${envId}`;

		// by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
		// and integration code is deterministic (if you add a new IA module,
		// the 1st one will be rendered, not the last one)
		if (!accumulator[combinedAppEnvId]) {
			accumulator[combinedAppEnvId] = current;
		}

		return accumulator;
	}, {});
